"use strict";
// Workflow System Enums
exports.__esModule = true;
exports.HttpMethod = exports.DelayUnit = exports.ActionType = exports.LogStatus = exports.ExecutionStatus = exports.BranchType = exports.WorkflowBlockType = exports.ScheduleFrequency = exports.EventType = exports.TriggerType = void 0;
var TriggerType;
(function (TriggerType) {
    TriggerType["CONTACT_CREATED"] = "contact_created";
    TriggerType["CONTACT_UPDATED"] = "contact_updated";
    TriggerType["ACTIVITY_CREATED"] = "activity_created";
    // ACTIVITY_UPDATED = 'activity_updated',
    TriggerType["SCHEDULE"] = "schedule";
})(TriggerType = exports.TriggerType || (exports.TriggerType = {}));
var EventType;
(function (EventType) {
    EventType["CREATE"] = "create";
    EventType["UPDATE"] = "update";
    // DELETE = 'delete'
})(EventType = exports.EventType || (exports.EventType = {}));
var ScheduleFrequency;
(function (ScheduleFrequency) {
    ScheduleFrequency["DAILY"] = "daily";
    ScheduleFrequency["WEEKLY"] = "weekly";
    ScheduleFrequency["MONTHLY"] = "monthly";
})(ScheduleFrequency = exports.ScheduleFrequency || (exports.ScheduleFrequency = {}));
var WorkflowBlockType;
(function (WorkflowBlockType) {
    WorkflowBlockType["ACTION"] = "action";
    WorkflowBlockType["DELAY"] = "delay";
    WorkflowBlockType["API"] = "api";
    WorkflowBlockType["FILTER"] = "filter";
    WorkflowBlockType["IF_ELSE"] = "if_else";
})(WorkflowBlockType = exports.WorkflowBlockType || (exports.WorkflowBlockType = {}));
// export enum ConditionOperator {
//     EQUALS = 'equals',
//     NOT_EQUALS = 'not_equals',
//     CONTAINS = 'contains',
//     GREATER_THAN = 'greater_than',
//     LESS_THAN = 'less_than',
//     IS_EMPTY = 'is_empty',
//     IS_NOT_EMPTY = 'is_not_empty',
//     CHANGED = 'changed',
//     NOT_CHANGED = 'not_changed'
// }
var BranchType;
(function (BranchType) {
    BranchType["IF"] = "if";
    BranchType["ELSE_IF"] = "else_if";
    BranchType["ELSE"] = "else";
})(BranchType = exports.BranchType || (exports.BranchType = {}));
var ExecutionStatus;
(function (ExecutionStatus) {
    ExecutionStatus["RUNNING"] = "running";
    ExecutionStatus["COMPLETED"] = "completed";
    ExecutionStatus["FAILED"] = "failed";
    ExecutionStatus["PAUSED"] = "paused";
})(ExecutionStatus = exports.ExecutionStatus || (exports.ExecutionStatus = {}));
var LogStatus;
(function (LogStatus) {
    LogStatus["SUCCESS"] = "success";
    LogStatus["ERROR"] = "error";
    LogStatus["INFO"] = "info";
    LogStatus["IN_PROGRESS"] = "in_progress";
    LogStatus["SKIPPED"] = "skipped";
    LogStatus["CONDITION_NOT_MET"] = "condition_not_met";
})(LogStatus = exports.LogStatus || (exports.LogStatus = {}));
var ActionType;
(function (ActionType) {
    ActionType["CREATE_CONTACT"] = "create_contact";
    ActionType["UPDATE_CONTACT"] = "update_contact";
    ActionType["CREATE_ACTIVITY"] = "create_activity";
    // UPDATE_ACTIVITY = 'update_activity',
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var DelayUnit;
(function (DelayUnit) {
    DelayUnit["MINUTES"] = "minutes";
    DelayUnit["HOURS"] = "hours";
    DelayUnit["DAYS"] = "days";
    // WEEKS = 'weeks'
})(DelayUnit = exports.DelayUnit || (exports.DelayUnit = {}));
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["DELETE"] = "DELETE";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
